import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ScrollView, Text, useWindowDimensions, View } from 'react-native'
import { useSelector } from 'react-redux';
import { useCssStyle } from '../../customHook/getCssStyle';
import CustomPressable from '../../components/customPressable/customPressable';
import { ImageComp } from '../../components/Image/Image';
import { CHEVRON_RIGHT } from '../../assets';
import HeaderWithBack from '../../components/Header/headerWithBack';
import DatePickerModal from '../../components/datePickerModal/datePickerModal';
import moment from 'moment';
import { CustomTextInput } from '../../components/customTextInput';
import { formatDate } from '../../js/formatDate';
import CustomFlatList from '../../components/customFlatList';

const ActivitiesEventList2 = (props) => {
    const { loading, events, currentPage, selectedEvent, setSelectedEvent, handleGetAvailability, availableDates, handleNext, handleGoBack } = props;

    const { t } = useTranslation();
    const { width } = useWindowDimensions()
    const getStyles = useCssStyle();

    const { extraConfigParam } = useSelector((state) => state.deviceConfigSlice);
    const dateFormat = extraConfigParam?.DATE_FORMAT;

    const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);
    const isNonRecurringEvent = Boolean (selectedEvent?.event?.kind=="event" && selectedEvent?.eventInfo.firstAvailableDate && selectedEvent?.eventInfo.firstAvailableDate.scheduledDate);

    const [subevent, setSubevent] = useState()


    useEffect(()=> {

        if(selectedEvent?.event?.kind !== "resource"){
            setSubevent(null)
        }

    }, [selectedEvent?.event?.kind])

    
    const handleNextSubEvent = (item) => {
        if(!item) {
            if(!subevent){
                handleNext(selectedEvent.event);
            }
            else {
                handleNext(subevent);
                handleGetAvailability(subevent);
            }

        } else {
            if(selectedEvent?.event?.kind !== "resource"){
                handleNext(item);
            } else {
                setSubevent(item);
            }
        }
    }

    const renderEventItem = ({ item }) => {
        const imageUri =
            item.coverMedia?.uri?.original ||
            item.coverMedia?.uri?.['1080w'] ||
            item.coverMedia?.uri?.['750w'] ||
            item.coverMedia?.uri?.['640w'] ||
            (Array.isArray(item.pictures) && item.pictures[0]?.uri?.original) ||
            null;


        return (
            <CustomPressable
                onPress={() => handleNextSubEvent(item)}
                style={getStyles([selectedEvent ? "list_itemContainer" : "", , 'activitiesSubEventListItemContainer', subevent?.id === item?.id ? "activitiesEventList_itemContainer_selected" : "" ])}
                key={item.id ?? `${item.title}`}
                id={'activitiesSubEventListItemContainer'}
            >
                {imageUri ? (
                    <ImageComp
                        source={imageUri}
                        style={getStyles([selectedEvent ? 'list_itemContainer_image' : "", 'activitiesSubEventListItemImage', subevent?.id === item?.id ? "activitiesEventList_itemContainer_image_selected" : ""])}
                        id={'activitiesSubEventListItemImage'}
                    />
                ) : null}

                <View style={getStyles([selectedEvent ?  'list_itemContainer_textContainer' : "", subevent?.id === item?.id ? "activitiesSubEvent_itemContainer_textContainer_selected" : "",  'activitiesEventListItemSubContent'])} id='activitiesEventListItemSubContent'>
                    
                    <Text numberOfLines={2} style={getStyles([selectedEvent ?  'list_itemContainer_textContainer_title' : "", subevent?.id === item?.id ? "activitiesEventList_itemContainer_textContainer_title_selected" : "", 'activitiesEventListItemTitle'])} id='list_itemContainer_textContainer_title activitiesEventListItemTitle'>
                        {item.title ?? item.name ?? 'Untitled'}
                    </Text>

                    {item?.startingPrice && item?.supportedCurrencies ? <Text style={getStyles([selectedEvent ?  'list_itemContainer_textContainer_subtitle' : "", subevent?.id === item?.id ? "activitiesEventList_itemContainer_textContainer_subtitle_selected" : "",'activitiesEventListItemSubtitle'])} id='list_itemContainer_textContainer_subtitle activitiesEventListItemSubtitle'>
                        Starting from : {item.supportedCurrencies[0] + " " + parseFloat(item.startingPrice).toFixed(2)}
                    </Text> : null}
                </View>

                <View style={getStyles(['list_itemContainer_arrow', 'activitiesEventList_itemContainer_arrow'])} >
                    <ImageComp source={CHEVRON_RIGHT} style={getStyles(['list_itemContainer_arrow_img'])}/>
                </View>
            </CustomPressable>
        );
    };

    return (
        <View style={getStyles(["widgetRootContainer", "activitiesEventListRootContainer"])} id='activitiesEventListRootContainer'>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />

            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'activitiesEventListMainContainer'])} 
                showsVerticalScrollIndicator={false}
                id='activitiesBookingMainContainer'
            >
                <View style={getStyles(['widgetmainContainerChildContainer', 'activitiesSubEventListMainContainerChildContainer'])} id='activitiesSubEventListMainContainerChildContainer'>
                    
                    {selectedEvent?.event && 
                        <View style={getStyles(['activitiesEventListTextContainer'])} id='activitiesEventListTextContainer'>
                            {selectedEvent?.event?.title && <Text style={getStyles(['label', 'activitiesEventTitleText'])} id='label activitiesEventTitleText'> {selectedEvent?.event?.title} </Text>}
                        </View>}

                    {events?.length === 0 ? (
                        null
                    ) : (
                        <View style={getStyles(['activitiesEventListContainer'])}> 
                            <CustomFlatList
                                data={events}
                                keyExtractor={(item) => item.id ?? `${item.title}-${Math.random()}`}
                                renderItem={renderEventItem}
                                showsVerticalScrollIndicator={false}
                            />
                        </View>
                    )}
                </View>
            </ScrollView>


            <View id='activitiesBookingNextButtonContainer' style={getStyles(['activitiesBookingNextButtonContainer'])}>
                <CustomPressable 
                    style={getStyles(['primaryBtn'])} 
                    onPress={() => handleNextSubEvent()} 
                    id="primaryBtn"
                    disabled={selectedEvent?.event?.kind === "resource" ? !subevent :  !(selectedEvent?.selectedDate || isNonRecurringEvent)}
                >
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
                        {t('way_activity.event_list.button')}
                    </Text>
                </CustomPressable>
            </View>
        </View>
    )
}

export default ActivitiesEventList2
